module.exports = __webpack_public_path__ + "img/myTourAgents.da9ccd8f.svg";